// Raw input, answered (stoneheim ui/interact.js port). ONE delegated
// listener turns every press anywhere in the app into a spark at the pointer
// — the universal "it registered" mark — plus a sound voice for controls
// that don't already speak (buttons play their own via kbtn). Disabled form
// controls never dispatch events at all, so refusals are found by
// hit-testing the point: the deny spark + shake + reason fire from here.
// Visual half lives in css/interact.css (.fx-spark).

import { el, denyPress } from './kit';
import * as sfx from './audio/sfx';
import { reducedMotion } from './ui';

// selector -> sound cue for controls without their own voice. First match
// wins; buttons/links are silent here (kbtn owns their click sound).
const CUES: [string, string][] = [
  ['.inv-slot', 'ui_tap'],
  ['.craft-fold', 'ui_tap'],
];
const SILENT = 'button, a, input, .k-btn';

// a ring expanding from a screen point — body-anchored so it can't disturb
// the layout of whatever was clicked
export function spark(x: number, y: number, cls = ''): void {
  if (reducedMotion() || !document.body) return;
  const s = el('div', { class: `fx-spark ${cls}`, style: `left:${x}px;top:${y}px` });
  document.body.append(s);
  setTimeout(() => s.remove(), 500);
}

let lastCue = 0;

export function installInteractions(root: Document = document): void {
  // capture, so nothing that stops propagation can swallow the feedback
  root.addEventListener(
    'pointerdown',
    (e: PointerEvent) => {
      if (e.button !== 0) return;
      const target = e.target as HTMLElement | null;
      // a disabled control is inert: find it by hit-testing the point
      const under = root.elementFromPoint?.(e.clientX, e.clientY) as HTMLElement | null;
      const dead = under?.closest?.('button:disabled') as HTMLElement | null;
      if (dead) {
        spark(e.clientX, e.clientY, 'deny');
        denyPress(dead, dead.dataset.denyReason || null);
        return;
      }
      spark(e.clientX, e.clientY);
      // voices for pressables that have none of their own; bursts (drags,
      // double-taps) collapse to one cue per 45ms so it never reads glitchy
      const now = Date.now();
      if (now - lastCue < 45) return;
      if (!target || target.closest?.(SILENT)) return;
      for (const [sel, cue] of CUES)
        if (target.closest?.(sel)) {
          lastCue = now;
          sfx.playEvent(cue);
          return;
        }
    },
    true,
  );
}
